import { formatGs } from "@/lib/format";

export const WA_DISPLAY = "0994 945 144";
export const WA_NUMBER = "595994945144";

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const waGeneral = () =>
  waLink("¡Hola Kuki Impresiones! Vi su catálogo web y me gustaría consultar por disponibilidad y hacer un pedido.");

export const waProduct = (p) =>
  waLink(`¡Hola Kuki Impresiones! Me interesa el producto: ${p.name} (Precio: ${formatGs(p.price)}). ¿Tienen disponibilidad?`);

export const buildOrderMessage = ({ name, phone, city, delivery, notes, cart, total }) => {
  const lines = ["¡Hola Kuki Impresiones! Quiero hacer un pedido:", ""];
  cart.forEach((i) =>
    lines.push(`• ${i.name} x${i.qty} — ${formatGs(i.price * i.qty)}`)
  );
  if (notes) lines.push("", `Pedido adicional: ${notes}`);
  lines.push(
    "",
    `Total estimado: ${formatGs(total)}`,
    `Nombre: ${name}`,
    `Teléfono: ${phone}`,
    `Ciudad: ${city}`,
    `Entrega: ${delivery}`,
    "",
    "Entiendo que para apartar o personalizar se requiere la seña del 50% y el pago total antes del retiro o despacho."
  );
  return lines.join("\n");
};
